import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../core/service/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource } from '@angular/material/table';
import { wmCallList } from './wmCallList';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { openLostCustomerLeadUpdateDialog } from 'src/app/modal/lost-customer-lead-update-dialog/lost-customer-lead-update-dialog.component';


@Component({
	selector: 'app-workshop-manager-calling-list',
	templateUrl: './workshop-manager-calling-list.component.html',
	styleUrls: [ './workshop-manager-calling-list.component.css' ]
})
export class WorkshopManagerCallingListComponent implements OnInit {
	@ViewChild(MatSort, { static: true })
	sort: MatSort;
	@ViewChild(MatPaginator, { static: true })
	paginator: MatPaginator;

	displayedColumns: string[] = [
		'customerName',
		'vin',
		'callType',
		'callStatus',
		'leadClosureResponse',
		'leadRemovalDate',
		'custTel',
		'disengageReason',
		'proposal',
		'visitProposal'
	];

	spinner: boolean;
	dataSource: any;
	userId: string;
	userInfo: any;
	countryCode: string;
	listSize: number = 0;
	uniqueRequest = new Set<string>();
	uniqueSourceId = new Set<string>();
	customerCode: any;
	vin: any;
	leadStatus: any;
	showLeadDailog: any=false;
	pageSize: number

	constructor(private commonService: CommonService, private toastr: ToastrService, public dialog: MatDialog) {}

	ngOnInit() {
		this.userId = localStorage.getItem('userId');
		this.countryCode = localStorage.getItem('countryCode');
		this.applyfilter();

		if (localStorage.getItem('WMcallListPageSize') != null || localStorage.getItem('WMcallListPageSize') != undefined) {
			let pagesize = Number(localStorage.getItem('callListPageSize'));
			this.pageSize = (pagesize && pagesize != NaN) ? pagesize : 50;
		  } else {
			this.pageSize = 50;
		  }
	}

	/**
   * Name: searchfilter
   * purpose: To apply filter on datagrid
   */
	searchfilter(filterValue: string): void {
		filterValue = filterValue.trim(); // Remove whitespace
		filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
		this.dataSource.filter = filterValue;
	}

	/**
   * Name: applyfilter
   * purpose: To apply filter on call list data
   */
	applyfilter(): void {
		this.spinner = true;
		this.dataSource = '';

		this.commonService.fetchWmCloseLeads(this.userId).subscribe(
			(res) => {
				if (res['responseCode'] == 0 && res['responseData'] != undefined) {
					let response = res['responseData'];
					this.listSize = response.length;
					//init data table and shorting
					this.dataSource = new MatTableDataSource<wmCallList>(response);
					this.sort.direction = '';
					this.dataSource.sort = this.sort;
					this.dataSource.sortingDataAccessor = (data, header) => data[header];
					this.dataSource.paginator = this.paginator;
					this.filterData();
					this.spinner = false;
				} else {
					this.spinner = false;
					this.toastr.error(res['message'], 'Error');
					// this.callToggleStatus = true;
				}
			},
			(err) => {
				this.spinner = false;
				this.toastr.error('Something went wrong, Please try again.', 'Error');
				// this.callToggleStatus = true;
			}
		);
	}

	/**
   * Name: filterData
   * purpose: To filter call list data
   */
	filterData(): void {
		this.dataSource.filteredData.forEach((element) => {
			this.uniqueRequest.add(element.requestStatus);
			this.uniqueSourceId.add(element.sourceId);
		});
	}

	selectCustomer(row) {
		this.customerCode = row.customerCode;
		this.vin = row.vin;
		this.showLeadDailog=true;
		openLostCustomerLeadUpdateDialog(this.dialog, this.customerCode).subscribe(val=>{
        if(val == -1){
			this.applyfilter();
		}
		});
	}

	/**
  * Name: setPageData
  * purpose: To set pagesize for table
  */
	setPageData(event) {
		let size = event.pageSize.toString();
		localStorage.setItem('WMcallListPageSize', size);
	  }
}


